import { Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Member } from '../member.model';
import { MembersService } from '../members.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-members-detail',
  templateUrl: './members-detail.component.html',
  styleUrls: ['./members-detail.component.css']
})
export class MembersDetailComponent implements OnInit {
  
  public member:Member;

  private detailSubscription:Subscription;

  constructor(public memberServ: MembersService,public navigator:Router,public toastr:ToastrManager) {
    this.detailSubscription=new Subscription();
   }

  ngOnDestroy(): void {
    if(this.detailSubscription) return

    this.detailSubscription.unsubscribe();
  }

  ngOnInit() {
    this.detailSubscription.add(this.memberServ.getObject('member').subscribe(member=>this.member=member));
  }

  editMember(member:Member){
    this.navigator.navigate(['/admin/members/edit']).then(()=>{
      this.memberServ.setObject(member,'member');
    })
  }

  updateImageProfile(event:any,member:any){

    if(confirm('Deseja realmente actualizar o Logotipo?')){

            // criando um formData
            let formData = new FormData();


            // convertendo o formpartner para formData
            formData.append('id', member['id'])
      
            // Anexando a imagem
            if(event.target.files[0])
              formData.append('photo', event.target.files[0], event.target.files[0].name)

      // save image
      this.memberServ.updateImageWithNoData(formData,'member')
      .subscribe(message=>{
        this.toastr.successToastr(message)
      })

    }
  }

}
